import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import Box from "../../components/Box/Box";
import Label from "../../components/Label";
import BodyContainer from "./BodyContainer";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RESET_LINK_SUCCESS } from "../../redux/UserReducer/userActionType";
import ResponseContainer from "../../components/SuccessPage/ResponseContainer";

const ForgetPage = () => {
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({});
  
 const {t} = useTranslation()
  useEffect(() => {
    return () => {
      dispatch({
        type: RESET_LINK_SUCCESS,
        isFetching: false,
        isResetLinkSend: false,
      });
    };
  }, []);


  const isResetLinkSend = useSelector(
    (state) => state.userReducer?.isResetLinkSend
  );

//   useEffect(()=>{
// if(isResetLinkSend){

// }
//   },[isResetLinkSend])

  return (
    <div>
      {console.log('isResetLinkSend',isResetLinkSend)}
      <Banner link={"/login"} type='forget-password' title={ isResetLinkSend ? 'Check your Email' : 'Enter Email To Reset Password' } />
      {!isResetLinkSend ? (
        <BodyContainer
          userDetails={userDetails}
          setUserDetails={setUserDetails}
        />
      ) : (
        <ResponseContainer>
          
          <Box display="flex" flexDirection="column" alignItems="center">
            <Label
              color="#1A1A1A"
              variant="text2"
              fontWeight={700}
              lineHeight="24px"
            >
              {t('Password Reset Link Sent')}
            </Label>
            <Label
              color="#7E7E7E"
              variant="text5"
              fontWeight={500}
              lineHeight="24px"
              mt="16px"
            >
              {t('We have sent password reset link to')}
            </Label>
            <Label
              color="#222222c2"
              variant="text5"
              fontWeight={600}
              lineHeight="24px"
              mt="4px"
            >
              {userDetails?.email}
            </Label>
            <Label
              color="#7E7E7E"
              variant="text5"
              fontWeight={500}
              lineHeight="24px"
              mt="12px"
            >
              {t('Kindly open your gmail and click on the link')}
            </Label>
            <Label
              color="#7E7E7E"
              variant="text5"
              fontWeight={500}
              lineHeight="24px"
              mt="4px"
            >
              {t('sent to you.')}
            </Label>
          </Box>
        </ResponseContainer>
      )}
    </div>
  );
};

export default ForgetPage;
